import styled from "styled-components";

export const ContentWrapper = styled.div`
    max-width: 35%;
    margin: 40px auto auto;
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 30px;

    @media (max-width: 768px) {
        max-width: 100%;
        padding: 0 20px 20px;
    }

    div {
        text-align: left;
    }

    span {
        font-family: Inter;
    }
`;

export const Error = styled.span`
  color: #f9123b;
  font-family: Inter;
  text-align: right;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 15.6px;
`;

export const SectionTitle = styled.p`
    font-family: Inter,serif;
    font-size: 18px;
    font-weight: 500;
    line-height: 28px;
    text-align: left;
`;

export const EditButton = styled.button`
    font-family: Inter,serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;
    text-align: center;
    color: var(--primary-brand);
`;

export const DetailsBox = styled.div`
  padding: 24px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const DetailsLabel = styled.p`
    font-family: Inter, serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    color: #adadad;
`;

export const DetailsValue = styled.p`
    font-family: Inter,serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: right;
    color: #000000;
`;

export const WalletAddress = styled.p`
    font-family: Inter,serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: right;
    color: #000000;
    display: inline-block;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media(max-width: 768px) {
        max-width: 100px;
    }
`

export const RateBox = styled.div`
    height: 40px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    border-radius: 8px;
    background-color: #f9f9f9;

    span {
        color: #000000;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        font-family: Inter;
    }

    .fee-box {
        display: flex;
        align-items: center;
        gap: 5px;
    }
`;